import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

import { TrialBalanceThresholdPropTypes } from '../../shared/propTypes/TrialBalanceThreshold';

import {
  sharedActions,
} from './store/actions';

const TrialBalanceThresholdAdminColumnRenderer = props => {
  const {
    showModalTrialBalanceThresholdForEdit,
    value: entity,
  } = props;

  const showEditModal = useCallback(() => {
    showModalTrialBalanceThresholdForEdit(entity);
  }, [showModalTrialBalanceThresholdForEdit, entity]);

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Trial Balance Out of Balance Threshold"
        onClick={showEditModal}
      >
        <PencilIcon size={16} className="cell-icon"/>
      </button>
    </div>
  );
};

TrialBalanceThresholdAdminColumnRenderer.propTypes = {
  showModalTrialBalanceThresholdForEdit: PropTypes.func.isRequired,
  value: TrialBalanceThresholdPropTypes.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default connect(null, {
  showModalTrialBalanceThresholdForEdit: sharedActions.showModalForAddEdit,
})(TrialBalanceThresholdAdminColumnRenderer);
